import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import MenuPrincipal from "./MenuPrincipal";
import fondo from "./ismaael.jpeg";
import { apiUrl } from "./mangaApi";
import "./INIDEPRUEBA.css";
import "./ServerMangaPage.css";

const imageUrl = (value = "") =>
  value.startsWith("http") ? value : `/${value.replace(/^\/+/, "")}`;

export default function ServerMangaPage({ suggestions = [] }) {
  const { slug } = useParams();
  const [manga, setManga] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError("");

    fetch(apiUrl(`/catalog/${encodeURIComponent(slug)}`), {
      signal: controller.signal,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("No se encontró este manga publicado.");
        }
        return response.json();
      })
      .then(setManga)
      .catch((requestError) => {
        if (requestError.name !== "AbortError") {
          setError(requestError.message);
        }
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  }, [slug]);

  const suggestedComics = useMemo(
    () =>
      suggestions
        .filter(
          (comic) =>
            comic.mangaId !== manga?.id &&
            comic.enlace !== `/manga/${slug}`
        )
        .slice(0, 5),
    [manga?.id, slug, suggestions]
  );

  if (loading) {
    return (
      <div className="server-manga-state">
        <strong>Cargando información del manga…</strong>
      </div>
    );
  }

  if (error || !manga) {
    return (
      <div className="server-manga-state">
        <strong>{error || "No se encontró el manga."}</strong>
        <Link to="/">Volver al inicio</Link>
      </div>
    );
  }

  const latestChapter = manga.chapters?.[0];
  const information = [
    ["Autor", manga.author],
    ["Artista", manga.artist],
    ["Tipo", manga.type],
    ["Idioma", manga.language],
    ["Grupo", manga.scanlationGroup || manga.publicationGroup],
    ["Revista", manga.magazine],
  ].filter(([, value]) => value);

  return (
    <div className="comic-base server-manga-page">
      <header
        className="header-futurista server-manga-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 8, 12, .72), rgba(0, 8, 12, .88)), url(${manga.coverUrl || fondo})`,
        }}
      >
        <h1 className="titulo-fx">{manga.title}</h1>
        <MenuPrincipal />
      </header>

      <main className="detalle-fx">
        <aside className="meta-fx">
          <h2>📘 Manga</h2>
          <div className="cover-fx server-cover">
            <img src={manga.coverUrl} alt={`Portada de ${manga.title}`} />
          </div>

          <table className="info-fx">
            <tbody>
              {information.map(([label, value]) => (
                <tr key={label}>
                  <td>{label}</td>
                  <td>
                    <span className="etiqueta-fx">{value}</span>
                  </td>
                </tr>
              ))}

              {manga.tags?.length > 0 && (
                <tr>
                  <td>Etiquetas</td>
                  <td>
                    <div className="etiquetas-group-fx">
                      {manga.tags.map((tag) => (
                        <Link
                          key={tag}
                          to={`/buscar?tag=${encodeURIComponent(tag)}`}
                          className="etiqueta-fx clickable"
                        >
                          {tag}
                        </Link>
                      ))}
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </aside>

        <section className="content-fx">
          <h2>
            📖 Páginas ({manga.pages?.length || 0})
          </h2>

          {manga.pages?.length > 0 && latestChapter ? (
            <div className="paginas-fx server-all-pages">
              {manga.pages.map((page, index) => (
                <Link
                  key={page}
                  to={`${latestChapter.readerUrl.slice(0, -1)}${index}`}
                  className="page-card"
                  title={`Abrir desde la página ${index + 1}`}
                >
                  <img src={page} alt={`Página ${index + 1} de ${manga.title}`} />
                </Link>
              ))}
            </div>
          ) : (
            <p className="server-empty">Este manga todavía no tiene páginas publicadas.</p>
          )}

          <section className="server-synopsis">
            <span>HISTORIA</span>
            <h2>Sinopsis</h2>
            <p>{manga.synopsis}</p>
            {manga.teamNote && <small>{manga.teamNote}</small>}
          </section>

          <h2 className="server-section-title">📚 Capítulos</h2>
          <div className="server-chapters">
            {manga.chapters.map((chapter) => (
              <Link key={chapter.id} to={chapter.readerUrl}>
                <div>
                  <strong>Capítulo {chapter.number}</strong>
                  {chapter.title && <span>{chapter.title}</span>}
                </div>
                <small>{chapter.pageCount} páginas</small>
                <b>Leer →</b>
              </Link>
            ))}
          </div>

          {suggestedComics.length > 0 && (
            <>
              <h2 className="server-section-title">⚡ Cómics sugeridos</h2>
              <div className="sugeridos-fx server-suggestions">
                {suggestedComics.map((comic, index) => (
                  <Link
                    key={comic.id}
                    to={comic.enlace}
                    className={`sugerido-fx sugerido-${index + 1}`}
                    style={{ "--img": `url("${imageUrl(comic.imagen)}")` }}
                    data-text={comic.nombre || `Cómic ${index + 1}`}
                  />
                ))}
              </div>
            </>
          )}
        </section>
      </main>

      <footer className="footer-fx">
        <p>&copy; 2026 TMOXNight — Todos los derechos reservados.</p>
      </footer>
    </div>
  );
}
